import { useEffect, useState } from "react";
import { parse } from "tldjs";
import { resolveSubdomain } from "utilities/subdomain";

const useGetSubdomain = () => {
  const [subdomain, setSubdomain] = useState<any>({});

  useEffect(() => {
    const { protocol, host, hostname, port } = window.location;
    let data = parse(`${protocol}//${host}`);
    const fullSubdomain = resolveSubdomain({ protocol, host, hostname });
    setSubdomain({
      ...data,
      subdomain: fullSubdomain.split(".")[0],
      fullSubdomain: fullSubdomain || undefined,
      domain: `${data?.domain}${port ? `:${port}` : ""}`,
    });
    return () => {};
  }, []);
  return subdomain;
};

export default useGetSubdomain;
